export default {
	1: 'Etwas ist schiefgelaufen. Versuchen Sie es später nochmals',
	2: 'Der Schlossserver auf Lager ist nicht verfügbar',

	1000: 'E-Mail-Adresse ist erforderlich',
	1001: 'Geben Sie die richtige E-Mail-Adresse ein',
	1002: 'Ihr Passwort ist erforderlich',
	1003: 'Pflichtfeld',
	1004: 'Nicht zulässige Zeichen-Zahl',

	1077: 'Keine aktuellen Rechnungen gefunden',

	5000: 'Der Kunde hat aktive Verträge. Bitte überprufen.',

	6001: 'Leider ist der Lagerraum schon gebucht. Bitte, wählen Sie einen anderen oder kontaktieren Sie den Kundendienst',
	6002: 'Unbekannter Nutzer',
	6003: 'Lagerraum oder Lager müssen bereitgestellt werden',
	6004: 'Der Nutzer wurde nicht gefunden',
	6005: 'Der Lagerraum wurde nicht gefunden',
	6006: 'Das Lager wurde nicht gefunden',
	6007: 'Dieser Lagerraum befindet sich nicht in diesem Lager. Bitte, wählen Sie einen anderen.',
	6008: 'Die IP-Adresse ist erforderlich',
	6009: 'Sie müssen sich mit dem Wi-Fi-Netzwerk des Lagers verbinden, um die Tür zu öffnen',
	6010: 'Entschuldigung, es gibt keine passenden Lagerräume mit den erforderlichen Abmessungen',
	6011: 'Die Schlossnummer wird bereits verwendet',
	6013: 'Konfiguration einer falschen Verriegelung',
	6014: 'Sie haben dem Vertragsangebot und seinen Anwendungen nicht zugestimmt.',


	7000: 'Keine tatsächliche Zahlung',
	7001: 'Ihr Account wurde nicht bestätigt. Sie dürfen diese Handlung nicht vollziehen',
	7002: 'Sie können das Lager außerhalb der Arbeitszeit nicht öffnen',
	7003: 'Der Vertragsbeginn ist noch nicht da',
	7005: 'Contract is not started',



	9000: 'Ein Nutzer mit angegebener E-Mail-Adresse existiert bereits.',
	9001: 'Sie haben ungültige Daten eingegeben.',
	9003: 'Bitte melden Sie sich an',

	unrecognized: 'Etwas ist schiefgelaufen. Versuchen Sie es später nochmals.',
	error: 'Fehler'
};
